(function () {
    'use strict';

    angular
        .module('app.helpText')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
            {
                state: 'helptext',
                config: {
                    abstract: true,
                    url: '/helptext',
                    template: '<ui-view/>',
                    settings: {
                        authMode: 1
                    },
                    resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            if (userService.tenantId() != 1) {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            },
            {
                state: 'helptext.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/helptext/list.html?v=' + opsIncludeVersion,
                    controller: 'HelpTextListController',
                    controllerAs: 'vm',
                    title: 'Help Text'
                }
            },
            {
                state: 'helptext.details',
                config: {
                    url: '/detail/:id',
                    templateUrl: 'app/helpText/details.html?v=' + opsIncludeVersion,
                    controller: 'HelpTextDetailController',
                    controllerAs: 'vm',
                    title: 'Help Text',
                    settings: {}
                }
            }
            

        ];
    }
})();
